export type KycStatus =
  | 'PENDING'
  | 'ID_SUBMITTED'
  | 'GUARANTOR_SUBMITTED'
  | 'CONSENT_GIVEN'
  | 'UNDER_REVIEW'
  | 'APPROVED'
  | 'REJECTED';

export interface TenantProfile {
  id: number;
  userId: number;
  organisationId: number;
  kycStatus: KycStatus;
  idDocumentUrl?: string;
  idDocumentType?: string;
  guarantorName?: string;
  guarantorEmail?: string;
  guarantorPhone?: string;
  guarantorIdUrl?: string;
  ndprConsentAt?: string;
  ndprConsentIp?: string;
  reviewedById?: number;
  reviewedAt?: string;
  rejectionReason?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
  /** Populated when fetching with user include */
  user?: { id: number; email: string; firstName?: string; lastName?: string };
  /** Populated when fetching manager view */
  reviewedBy?: { id: number; email: string; firstName?: string; lastName?: string };
}

export interface SubmitGuarantorRequest {
  guarantorName: string;
  guarantorEmail: string;
  guarantorPhone: string;
  guarantorIdUrl?: string;
}

export const KYC_STATUS_LABELS: Record<KycStatus, string> = {
  PENDING: 'Pending',
  ID_SUBMITTED: 'ID Submitted',
  GUARANTOR_SUBMITTED: 'Guarantor Submitted',
  CONSENT_GIVEN: 'Consent Given',
  UNDER_REVIEW: 'Under Review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const KYC_STATUS_COLORS: Record<KycStatus, string> = {
  PENDING: 'bg-gray-100 text-gray-700',
  ID_SUBMITTED: 'bg-blue-100 text-blue-700',
  GUARANTOR_SUBMITTED: 'bg-indigo-100 text-indigo-700',
  CONSENT_GIVEN: 'bg-purple-100 text-purple-700',
  UNDER_REVIEW: 'bg-yellow-100 text-yellow-700',
  APPROVED: 'bg-green-100 text-green-700',
  REJECTED: 'bg-red-100 text-red-700',
};

/** Steps in KYC order — used to compute progress */
export const KYC_STEP_ORDER: KycStatus[] = [
  'PENDING',
  'ID_SUBMITTED',
  'GUARANTOR_SUBMITTED',
  'CONSENT_GIVEN',
  'UNDER_REVIEW',
  'APPROVED',
];
